import { Injectable, InjectionToken } from '@angular/core';
import { CustomBaseStoreWithShops } from '@city/const';
import { CustomAddress } from '@core/const';
import { OccShopConverter } from '@core/utils';
import { CustomPointOfService } from '@shop/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class OccBaseStoreWithShopsNormalizer
  extends OccShopConverter
  implements Converter<CustomBaseStoreWithShops, CustomBaseStoreWithShops>
{
  convert(source: CustomBaseStoreWithShops, target?: CustomBaseStoreWithShops): CustomBaseStoreWithShops {
    if (target === undefined) {
      target = { ...(source as any) };
    }
    if (target.pointsOfService) {
      target.pointsOfService = target.pointsOfService
        .filter((store: CustomPointOfService) => store.address)
        .map((store: CustomPointOfService) => ({
          ...store,
          address: this.trimAddressFields(store.address),
        }))
        .map((store: CustomPointOfService) => ({
          ...store,
          addressFormatted: this.addressFormattedNormalize(store.address),
        }));
    }

    return target;
  }

  trimAddressFields(address: CustomAddress): CustomAddress {
    return {
      ...address,
      streetname: address.streetname?.trim(),
      streetnumber: address.streetnumber?.trim(),
      town: address.town?.trim(),
      postalCode: address.postalCode?.trim(),
      district: address.district?.trim(),
      cityDistrict: address.cityDistrict?.trim(),
      building: address.building?.trim(),
      appartment: address.appartment?.trim(),
      settlement: address.settlement?.trim(),
    };
  }
}

export const BASE_STORE_WITH_SHOPS_NORMALIZER = new InjectionToken<
  Converter<CustomBaseStoreWithShops, CustomBaseStoreWithShops>
>('BaseStoreNormalizer');
